import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { clientService } from "@/services/gap-client-service"
import type { GapClientConfig, CreateGapClientRequest, UpdateGapClientRequest } from "@/types/gap-client"

// Fetch all clients
export function useClients() {
  return useSWR(["clients"], () => clientService.getAll(), {
    revalidateOnFocus: false,
  })
}

// Fetch single client
export function useClient(clientId: string | null) {
  return useSWR(clientId ? ["clients", clientId] : null, () => clientService.getById(clientId!), {
    revalidateOnFocus: false,
  })
}

// Create client mutation
export function useCreateClient() {
  return useSWRMutation(
    ["clients"],
    async (_key: string[], { arg }: { arg: CreateGapClientRequest }): Promise<GapClientConfig> => {
      return clientService.create(arg)
    },
  )
}

// Update client mutation
export function useUpdateClient() {
  return useSWRMutation(
    ["clients"],
    async (
      _key: string[],
      { arg }: { arg: { clientId: string; data: UpdateGapClientRequest } },
    ): Promise<GapClientConfig> => {
      return clientService.update(arg.clientId, arg.data)
    },
  )
}

// Delete client mutation
export function useDeleteClient() {
  return useSWRMutation(["clients"], async (_key: string[], { arg }: { arg: string }): Promise<void> => {
    return clientService.delete(arg)
  })
}
